// Actions
export const PREMIUM_FETCH  = '[Premium] Fetch'

// Mutations
export const PREMIUM_META   = '[Premium] meta'
export const PREMIUM_OBTAIN = '[Premium] obtain'
export const PREMIUM_CLEAR  = '[Premium] clear'
export const PREMIUM_SET_LOADING = '[Premium] set loading'
